export const handleApiCall = async (call) => {
    try {
        const response = await call();
        return response.data;
    } catch (error) {
        console.error('API call error:', error);
        throw error.response && error.response.data ? error.response.data : error;
    }
};
